module.exports = __webpack_public_path__ + "img/9788958280842.e49edeac.jpg";